import React, { useContext, useRef } from 'react';
import { Button } from '@mui/material';
import { toMercator } from '@turf/projection';

import Tooltip from '@mui/material/Tooltip';
import { MapContext } from '../MapContext';
import { LayerContext} from '../LayerContext';

import { addRoiLayer } from "../../common/layer/addRoiLayer"


export const RegionCreateControls = ({ rois, fullDepthSgeFile }) => {

  const { map, draw }  = useContext(MapContext);
  const { dispatch } = useContext(LayerContext);
  const fileInputRef = useRef(null);

  const addRoi = (addedFeature, isMercator = false) => {
    const newRoi = createRoi(isMercator ? addedFeature : toMercator(addedFeature));
    console.log("newRoi", newRoi);
    dispatch({
      type: 'ADD_LAYER',
      payload: addRoiLayer(map.current, newRoi) 
    });
  }

  const createRoi = (feature) => {
    return {
      'id': `l-roi-${feature.id}`,
      'type': 'roi',
      'boundary': feature,
      'color': colorsTab10[rois.length % 10],
      'source': `s-${feature.id}`,
      'fgbSrc': Array.isArray(fullDepthSgeFile) ? fullDepthSgeFile : [fullDepthSgeFile]
    }
  }

  const handleClickCreate = (e) => {
    console.log(draw);
    if ( draw.current && draw.current.getAll() && draw.current.getAll().features ) {
      console.log(draw);
      const features = draw.current.getAll().features;
      console.log("draw features", features);
      const multipolygon = convertToMultiPolygon(features);
      if (multipolygon?.id) addRoi(multipolygon);
      draw.current.deleteAll();
    } else {
      console.log("no features")
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const geoJson = JSON.parse(e.target.result);
        addRoi(geoJson['features'][0], isEPSG3857(geoJson))
      } catch (error) {
        console.error('Error parsing GeoJSON: ', error);
      }
    };
    reader.readAsText(file);
  };

  // Function to trigger the hidden file input click event
  const handleClickUpload = () => {
    console.log(rois);
    fileInputRef.current.click();
  };

  return (
    <div>
    <Tooltip title="Create ROI from current drawing">
      <Button variant="outlined" 
        color="success" size="small" 
        onClick={handleClickCreate}>
        Create 
      </Button>
    </Tooltip>
    <Tooltip title="Load ROI from local GeoJSON file">
      <Button variant="outlined" 
        color="success" size="small" 
        onClick={handleClickUpload}>
        Upload
      </Button>
    </Tooltip>
    <input type="file" ref={fileInputRef} style={{ display: 'none' }} 
        onChange={handleFileUpload} accept=".geojson,application/json" />
    </div>
  );
}

function convertToMultiPolygon(features) {
  const polygons = [];
  let firstGeometryId = null;
  features.forEach((feature, index) => {
    if (feature.geometry.type === 'Polygon') {
      polygons.push(feature.geometry.coordinates);
      if (index === 0) {
        firstGeometryId = feature.id;
      }
    }
  });
  const multipolygon = {
    type: 'MultiPolygon',
    coordinates: polygons
  };
  return {
    type: 'Feature',
    geometry: multipolygon,
    id: firstGeometryId
  };
}

const isEPSG3857 = (geojson)=> {
  if (geojson.crs && geojson.crs.properties) {
    const crsName = geojson.crs.properties.name;
    return crsName === "EPSG:3857" || crsName === "urn:ogc:def:crs:EPSG::3857";
  } else {
    return false;
  }
}

const colorsTab10 = {
  0: '#1f77b4',
  1: '#ff7f0e',
  2: '#2ca02c',
  3: '#d62728',
  4: '#9467bd',
  5: '#8c564b',
  6: '#e377c2',
  7: '#7f7f7f',
  8: '#bcbd22',
  9: '#17becf',
  10: '#f5b3ae',
  11: '#a5dea4'
};

export default RegionCreateControls;
